// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"0d3676c8","27":"a642888b","174":"83e45722","216":"4f1bca00","272":"fe09cbe1","281":"f673444b","310":"a039da0a","432":"f19be4fb","488":"81549973","627":"cbf9a235","675":"b978f751","706":"2f99558d"}[chunkId] + ".chunk.js";
};